// extracted by mini-css-extract-plugin
export var column = "VideoCaption-module--column--e514f";
export var companyLink = "VideoCaption-module--companyLink--8a64c";
export var fadeInAnimation = "VideoCaption-module--fadeInAnimation--ab056";
export var linkedinIcon = "VideoCaption-module--linkedinIcon--a89d8";
export var position = "VideoCaption-module--position--f689e";
export var title = "VideoCaption-module--title--dbb2a";
export var videoDuration = "VideoCaption-module--videoDuration--4cab6";
export var wrapper = "VideoCaption-module--wrapper--06c8c";